import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
export type Step = 1 | 2 | 3;
const STEPS = ["Add files", "Adjust", "Download"] as const;

/** Add files → Adjust → Download, with the current step highlighted. */
export function StepIndicator(t0) {
  const $ = _c(4);
  const {
    current
  } = t0;
  let t1;
  if ($[0] !== current) {
    t1 = STEPS.map((label, i) => {
      const step = i + 1 as Step;
      const state = step < current ? "done" : step === current ? "current" : "todo";
      return <li key={label} aria-current={state === "current" ? "step" : undefined} className={cn("inline-flex items-center gap-1.5 rounded-full px-3.5 py-2", state === "done" && "bg-image-tint text-image-strong", state === "current" && "bg-ink text-canvas", state === "todo" && "bg-sand text-muted-foreground")}>{step} {label}{state === "done" && <><Check className="size-4" aria-hidden="true" /><span className="sr-only">(done)</span></>}</li>;
    });
    $[0] = current;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ol aria-label="Progress" className="flex flex-wrap gap-2 text-sm font-semibold">{t1}</ol>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}